<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4>{{ title | translate }}</h4>
        <button type="button" class="close" [attr.aria-label]="'common.close' | translate" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="vox-inline-message vox-inline-message_light-grey mb-3">
        <div>
          <i class="icon-small-alert"></i>
          <span>{{ message | translate }}</span>
        </div>
      </div>
      <vox-links-summary [language]="lang" [linkedEntities]="links"></vox-links-summary>
    </div>
  </div>
</div>